export default __webpack_public_path__ + "a9191588056e838d32a346be3448abbf.svg";